import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux';
import Iframe from "react-iframe";

export const WebboardService = () => {
    const webboardUrl = useSelector((state) => state.media.webboardUrl);
    const [showWebboard, setShowWebboard] = useState(false);
    const [isFullScreen, setIsFullScreen] = useState(false);

    const [customStyles, setCustomStyles] = useState({
        position: 'absolute',
        top: '150px',
        left: '50px',
        width: '35%',
        height: '50%',
        backgroundColor: 'rgba(255, 255, 255, 1)',
        zIndex: 100,
    });

    const toggleFullScreen = () => {

        if (isFullScreen) {
            setCustomStyles({
                position: 'absolute',
                top: '150px',
                left: '50px',
                width: '35%',
                height: '50%',
                backgroundColor: 'rgba(255, 255, 255, 1)',
                zIndex: 100,
            });
        } else {
            setCustomStyles({
                position: 'absolute',
                top: '0px',
                left: '0px',
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(255, 255, 255, 1)',
                zIndex: 100,
            });
        }

        setIsFullScreen(!isFullScreen);
    };

    useEffect(() => {
        //console.error("Usman webview inside show hide url " + webboardUrl);
        if (webboardUrl === null) {
            //console.error("HIDE IFRAME ");
            setShowWebboard(false);

        } else {
            //console.error("SHOW IFRAME WITH URL " + webboardUrl);
            setShowWebboard(true);
        }
    }, [webboardUrl])

    return (<>
        {showWebboard && (
            <div style={customStyles}>
                <Iframe
                    url={webboardUrl}
                    width="100%"
                    height="100%"
                    id="webboard-iframe"
                    style={{ position: 'relative' }}
                />
                 <button onClick={toggleFullScreen} 
                     style={{
                        position: "absolute",
                        bottom: "10px",
                        right: "10px",
                        backgroundImage: isFullScreen ? "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIwAAACMCAMAAACZHrEMAAAAYFBMVEX///8AAADh4eGsrKyRkZGYmJiDg4O9vb2bm5vMzMzz8/Pd3d25ubmGhobW1tbu7u5sbGxfX19OTk6ysrJFRUU2NjYkJCRXV1fFxcV5eXlxcXEREREICAg9PT0rKyumpqbHzKonAAADz0lEQVR4nO2b65KrKhCFB3ViNN7vUWPe/y33CKIoiIJ4qk5Vfz9SNQbaBSw0QM/PDwAAAAAAAAAAwP8JK74jqhdE6pX8ZCi/5rU8Eept5VoJ+iM0rSUco/aqfWMNaFdN/DocwJ0iWAtCgaKYuCT1fvmvmgGVrrx2XqEq5y//kphI2TXfqeJ7+4U1Xu1esroRrskVeU8hn6pa5i5FzuZ6gK8K2r2QCwfDmQJqGXGnMrmTdEbYIr3hFS3LEK+rB2fFrHuGahGY8BwPUQD3rJiVyWnDOAueRxSiwVekz0Ni/oa5Qpu1NaASDh/EO54RT1zE48NcfIjyc8o7bqKzEWNIC20lQg96ITqOS1owP9qE1tNjGyo6NuJ7JeZ325wrOOtg+AmMWlmNFhexyB9GvMurcRgxiaxCwogRTIFrrFxMxKSy8ukiZtOtJmBdTMTUsuL1LMagdxeYoCpijHp3YeluIiaTFc4mMYa9y6txiJhCVrYgYox7d4E2s+3Hz1JWlPxKbO8ZIwJ1MaaSlazYkka9uxAyt+hkBTum4C39MuIwN5GVY4qZ84sVBK4XWZg4jn0/VBXTkspWFHle4wa5q71KbZgW9lVZFFmtKqZHG5QXcBPxsI3Eck4Mz0evb16ymNpi+OXUKeJKEvLEi1JMqemaXBJS2r7X/gB3BwvjfaLctu3v0wnfbZLWdVaUFXmEpAd9HZEXQvfn+rqu06R9hM7z+xcs1xskAAAAAAAAAAAAAAAiL4osK/bNRXztLfyzg/0nfv9i3PnK6jrRTq9wOy4mZZDuJriS/RnNHUeagSBEulkk3X+ztMTctI2mJyb+3CGm1vR0xG+cqoop0izLiqL4lAPxfq29ERy7eeA2Hp6lmFZVTGb5I/EIjmBurmts1+uOyiEP5ianDzKKW9LI5jM+zPkjnvSOvpkPv/Cn9PCLTMPv1EGFeTUax4LNpEZ/Bh1oOXVgSk9v6WvBsIs1j5K9qdrHpBr2fPqEmOXEP+iNu3h1Pq2WfkAP0Iy5+FJiRtMbdbF6ysqbETNlrxlysUYyD6lCfw0adDGXW6Ge5jS7+OpIGUkAM+RiQYLnidQ4Lk+Pqsmu9I0oL+hE0qC9FWPCxTRn1kA6JXVxqavGaKIpXfdoungnZ1Y3BXf2jU7fXEhOdjnPrNSo9w1N3eGebng5JU/b9sdfVwPXA9TF0leJCGo4QV5QUB0mtPuPuhW0n/bNts+OCIR+IZxI9f8RG2NysWoKAlnAGf8nCOymQdk0dqeVk3+EVwyFRj7EK/COC6njG1xUAgAAAAAAAAAA/Af8AzobKFQjz3TLAAAAAElFTkSuQmCC')" : "url('data:image/png;base64,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')",
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        width: isFullScreen ? "50px" : "25px", 
                        height: isFullScreen ? "50px" : "25px", 
                        color: "white", 
                        border: isFullScreen ? "solid" : "none", 
                        borderColor : isFullScreen ? "black" : "none",
                        cursor: "pointer", 
                      }}
                     >
                    </button>
            </div>
        )}
    </>)
}
